import { Data2 } from '../../../features/data-types'
import { Measure, MeasureType } from '../state/types'

export const useMeasureBuilders = () => {
    const buildMeasure = (data: Data2) => {
        const { type, units, unitTypeId } = data
        const measure: Measure = {
            type: type! as MeasureType,
            units: units! as number,
            unitTypeId: unitTypeId! as string
        }

        return measure
    }

    return {
        buildMeasure
    }
}
